<template>
  <div class="bg" :style="{ fontFamily: fonts }">
    <!-- <home-header @changeFont="changeF"></home-header> -->
    <div class="success">
      <div class="successImg">
        <div class="tick">
          <div class="successText">预约成功</div>
        </div>
      </div>
    </div>
    <div class="meetingInfo">
      <div class="meetingName">
        <div class="classify">会议室：{{ orderDetail.meetname }}</div>
        <div class="classify">会议主题：{{ orderDetail.theme }}</div>
        <div class="classify">参会人：{{ attendeeName }}</div>
      </div>
      <div class="meetingTime">
        <div class="time">
          会议时间：{{ meetingDate }}({{ weekday }}) {{ startTime }}-{{
            endTime
          }}
        </div>
        <div class="time">预定人：{{ orderDetail.appointmenter }}</div>
      </div>
    </div>
    <div class="complete">
      <div class="comButton" @click="comHandle">
        <div class="comText">完成</div>
      </div>
      <div class="cancel" @click="cancelHandle">
        <div class="canText">取消预约</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import HomeHeader from "./header";
import { cancelOrder, getMeetModel } from "@/utils/request";
export default {
  // components: {
  //   HomeHeader
  // },
  data() {
    return {
      fonts: "",
      timeClock: null,
      meetingId: "",
      weekday: "",
      meetingDate: "",
      startTime: "",
      endTime: "",
      orderDetail: {},
      equipmentName: "",
      meetingName: "",
      attendeeName: "",
      attendees: [],
      confirmShow: false
    };
  },
  created() {
    this.orderDetail = this.$route.query.detail[0];
    this.meetingDate = moment(new Date(this.orderDetail.startTime)).format(
      "YYYY-MM-DD"
    );
    this.weekday = this.initweekday(this.meetingDate);
    this.startTime = moment(new Date(this.orderDetail.startTime)).format(
      "HH:mm"
    );
    this.endTime = moment(new Date(this.orderDetail.endTime)).format("HH:mm");
    this.attendees = this.$route.query.detail;
    this.meetingId = this.$route.query.detail[0].meetingId;
    this.equipmentName = this.$route.query.equipmentName;
    this.meetingName = this.$route.query.detail[0].meetname;
    // console.log(this.attendees)
    for (let i in this.attendees) {
      this.attendeeName += this.attendees[i].attendeeName + ", ";
    }
  },
  watch: {
    confirmShow(val) {
      console.log(val);
      if (val) {
        this.timeClock = null;
      } else {
        this.timeClock = setTimeout(() => {
          this.comHandle();
        }, 10000);
      }
    }
  },
  mounted() {
    if (!this.confirmShow) {
      this.timeClock = setTimeout(() => {
        this.comHandle();
      }, 10000);
    }
  },
  destroyed() {
    if (this.timeClock) {
      clearInterval(this.timeClock);
    }
  },
  methods: {
    // getMeetModels() {
    //   getMeetModel().then(res => {
    //     if (Number(res.code) === 0) {
    //       this.fontStyle = res.data.fontStyle;
    //     }
    //   });
    // },
    // 点击完成之后跳转
    comHandle() {
      this.$router.push({
        path: "/",
        query: {
          meetingId: this.meetingId,
          equipmentName: this.equipmentName,
          meetingName: this.meetingName
        }
      });
    },
    initweekday(date) {
      console.log(date);
      switch (new Date(date).getDay()) {
        case 0:
          return "星期日";
          break;
        case 1:
          return "星期一";
          break;
        case 2:
          return "星期二";
          break;
        case 3:
          return "星期三";
          break;
        case 4:
          return "星期四";
          break;
        case 5:
          return "星期五";
          break;
        case 6:
          return "星期六";
          break;
      }
    },
    // 取消预约
    cancelHandle() {
      this.confirmShow = true;
      this.$confirm("预约已成功，确定取消预约？", {
        confirmButtonText: "取消",
        cancelButtonText: "不取消",
        customClass: "myClass",
        cancelButtonClass: "cancelClass",
        confirmButtonClass: "confirmClass",
        center: true,
        showClose: false
      })
        .then(() => {
          const cancelData = {
            id: this.orderDetail.id
          };
          cancelOrder(cancelData).then(res => {
            console.log(res);
            if (Number(res.code) === 0) {
              this.$message.success(res.data);
              this.$router.push({
                path: "/cancel",
                query: {
                  detail: this.attendees,
                  equipmentName: this.equipmentName,
                  meetingName: this.meetingName,
                  attendeeName: this.attendeeName
                }
              });
            }
          });
        })
        .catch(() => {
          console.log(121);
          this.confirmShow = false;
        });
    },
    changeF(font) {
      this.fonts = font;
    }
  }
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  background: url(../assets/delay-bg.png);
  .success {
    width: 13%;
    height: 50%;
    margin: 0 auto;
    .successImg {
      width: 240px;
      height: 240px;
      background: url(../assets/delay-yuan.png) no-repeat;
      position: relative;
      top: 25%;
      .tick {
        width: 100%;
        height: 100%;
        background: url(../assets/delay-gou.png) no-repeat;
        position: relative;
        top: 24%;
        left: 30%;
        .successText {
          font-size: 36px;
          color: #fff000;
          font-family: SimHei;
          font-weight: bold;
          background: linear-gradient(0deg, #1cf7e9 0%, #2ad8ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          position: relative;
          top: 35%;
          right: 9%;
        }
      }
    }
  }
  .meetingInfo {
    width: 100%;
    height: 35%;
    display: flex;
    .meetingName {
      width: 50%;
      height: 45%;
      .classify {
        width: 50%;
        height: 76%;
        text-align: left;
        font-size: 30px;
        color: #666666;
        font-family: SimHei;
        font-weight: 400;
        margin: 0 auto;
      }
    }
    .meetingTime {
      width: 50%;
      height: 45%;
      .time {
        width: 100%;
        height: 76%;
        text-align: left;
        font-size: 30px;
        color: #666666;
        font-family: SimHei;
        font-weight: 400;
      }
    }
  }
  .complete {
    width: 35%;
    height: 15%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    .comButton {
      width: 234px;
      height: 80px;
      background: linear-gradient(0deg, #1bf7e9, #2ad7ff);
      border-radius: 4px;
      .comText {
        font-size: 30px;
        color: #ffffff;
        text-align: center;
        line-height: 80px;
      }
    }
    .cancel {
      width: 234px;
      height: 80px;
      background: #dadada;
      border-radius: 4px;
      .canText {
        font-size: 30px;
        color: #ffffff;
        text-align: center;
        line-height: 80px;
      }
    }
  }
}
@media screen and (max-width: 1500px) {
  .bg {
    background-position: 30% 50%;
    .complete {
      width: 45%;
    }
  }
}
</style>
<style>
.myClass {
  width: 800px;
  height: 300px;
  color: #333333;
}
.cancelClass {
  width: 192px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  color: #fff;
  background: #dadada;
  border: none;
  border-radius: 2px;
  background: linear-gradient(0deg, #1bf7e9, #2ad7ff);
  margin-right: 145px;
}
.confirmClass {
  width: 192px;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  color: #fff;
  background: #dadada;
  border: none;
  border-radius: 2px;
}
.el-message-box__message p {
  color: #333333;
  font-size: 30px;
  font-family: SimHei;
  font-weight: bold;
}
.el-message-box--center .el-message-box__content {
  height: 35%;
}
/* .el-button{
    width: 23%;
    height: 42px;
    background: linear-gradient(0deg, #1BF7E9, #2AD7FF);
    color: #ffffff;
    font-size: 25px;
    border-radius: 4px;
} */
.el-message-box__btns {
  display: flex;
  justify-content: space-evenly;
}
.el-message-box__btns button:nth-child(2) {
  background: #dadada;
  border-color: #dadada;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderSuccess.vue